/**
 * Mobile nav toggle open and menu items open
 */
export const mobileNavToggle = () => {
    const submenus = document.querySelectorAll(
        '.mobile-nav .primary-navigation .menu-item-has-children .toggle-children'
    );
    submenus.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.stopPropagation();
            if (el.classList.contains('menu-active')) {
                el.classList.remove('menu-active');
                el.parentNode.classList.remove('sub-menu-visible');
            } else {
                el.classList.add('menu-active');
                el.parentNode.classList.add('sub-menu-visible');
                
            }
        });
    });

    // mobile secondary nav

     const secondarysubmenus = document.querySelectorAll(
        '.mobile-nav .top-navigation .menu-item-has-children .toggle-children'
    );
    secondarysubmenus.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.stopPropagation();
            if (el.classList.contains('menu-active')) {
                el.classList.remove('menu-active');
                el.parentNode.classList.remove('sub-menu-visible');
            } else {
                el.classList.add('menu-active');
                el.parentNode.classList.add('sub-menu-visible');
                
            }
        });
    });


}
